import { defineStore } from 'pinia';

import { sleep } from '@/shared/helpers';
import { useNotificationStore } from '@/shared/model';

export const useLphSave = defineStore('lphSave', {
  state: () => {
    return {
      hasDelay: false,
      notify: useNotificationStore(),
    };
  },
  actions: {
    async setDelay() {
      this.hasDelay = true;
      this.notify.notifySuccess(
        'Повторное сохранение будет доступно через 5 секунд'
      );
      await sleep(5000, true);
      this.hasDelay = false;
    },
  },
});
